// common
import '@ungap/custom-elements' // fix safari
import './scrollbar-width'
import './button'
import './icons'
import './sliders'
import './photos'
import './webcomponent/menu'
import './webcomponent/tooltip'
import './webcomponent/range-input'
import './menu'
import './reveal'
import './sommaire'
import './cta-tel'
import './form-simulation'
import './data-calendly'
import './modal-bulletin'
import './modal-rappel'

// blocks
import './blocks/master-details'
import './blocks/news'
import './blocks/agencies'
import './blocks/offers'
import './blocks/form-contact'
import './blocks/form-meetings'
import './blocks/form-offer'
import './blocks/form-subscriptions'
import './blocks/form-tom'
import './blocks/entretiens'

// eslint-disable-next-line no-console
console.log('Ok ! ')
